import React, { lazy } from 'react'
import AddOnImpl from 'live/api/add-on'
import liveUiService from 'live/services/ui'
import Router from 'live/services/router'
import MenuService from 'live/services/menu'
import { LiveApi } from 'live/lib/api'
import i18n from 'live/services/i18n'
import authorization from 'live/services/authorization'

import { addi18n, KPIPluginConfiguration } from './kpiConfiguration/config'
import { DataPersistenceConfiguration } from './dataPersistence/config'
import '../shared'
import { withSuspenseWrapper } from './components/SuspenseWrapper'
import { themeAwardWidgetDecorator } from './utils/utils'

const WrapperSelectKpisFilter = withSuspenseWrapper(React.lazy(() => import('./dashboardFilters/index')))

liveUiService.registerAddOn(
    liveUiService.uiSections.DASHBOARD_VIEW_MAIN_HEADER,
    new AddOnImpl(WrapperSelectKpisFilter, { order: -20 })
)

const PerformanceShell = themeAwardWidgetDecorator(
    withSuspenseWrapper(lazy(() => import('./fleetOverview/PerformanceShellPage')))
)

type PerformanceView = import('./fleetOverview/PerformanceShellPage').PerformanceView

const registerPerformanceRoute = (path: string, alias: string, performanceView: PerformanceView): void => {
    Router.route(path, PerformanceShell, alias, {
        hideFooter: true,
        performanceView
    })
}

const hasPermissionToView =
    authorization.superAdmin ||
    authorization.admin ||
    authorization.Permission.ADMIN ||
    authorization.Permission.OGPERFORMANCE_MANAGE_KPI ||
    authorization.Permission.OGPERFORMANCE_ADMINISTRATE_KPI ||
    authorization.Permission.OGPERFORMANCE_VIEW_KPI

if (hasPermissionToView) {
    registerPerformanceRoute('performance', 'performance', 'overview')
    registerPerformanceRoute('performance{?query}', 'performance', 'overview')
    registerPerformanceRoute('performance/omission-kpi', 'performance-omission-kpi', 'omission-kpi')
    registerPerformanceRoute('performance/omission-kpi{?query}', 'performance-omission-kpi', 'omission-kpi')
    registerPerformanceRoute('performance/data-qaqc', 'performance-data-qaqc', 'data-qaqc')
    registerPerformanceRoute('performance/data-qaqc{?query}', 'performance-data-qaqc', 'data-qaqc')
    registerPerformanceRoute('performance/kpi-drilling', 'performance-kpi-drilling', 'kpi-drilling')
    registerPerformanceRoute('performance/kpi-drilling{?query}', 'performance-kpi-drilling', 'kpi-drilling')
    registerPerformanceRoute('performance/kpi-goals', 'performance-kpi-goals', 'kpi-goals')
    registerPerformanceRoute('performance/kpi-goals{?query}', 'performance-kpi-goals', 'kpi-goals')
    registerPerformanceRoute('performance/data-aggregation', 'performance-data-aggregation', 'data-aggregation')
    registerPerformanceRoute(
        'performance/data-aggregation{?query}',
        'performance-data-aggregation',
        'data-aggregation'
    )
    registerPerformanceRoute('performance/dynamic-dashboards', 'performance-dynamic-dashboards', 'dynamic-dashboards')
    registerPerformanceRoute(
        'performance/dynamic-dashboards{?query}',
        'performance-dynamic-dashboards',
        'dynamic-dashboards'
    )
    registerPerformanceRoute(
        'performance/dynamic-dashboards/dashboard/{id}',
        'performance-dynamic-dashboard',
        'embedded-dynamic-dashboard'
    )
    registerPerformanceRoute(
        'performance/dynamic-dashboards/dashboard/{id}{?query}',
        'performance-dynamic-dashboard',
        'embedded-dynamic-dashboard'
    )
    registerPerformanceRoute('performance/dashboard/{id}', 'performance-dashboard', 'embedded-dashboard')
    registerPerformanceRoute('performance/dashboard/{id}{?query}', 'performance-dashboard', 'embedded-dashboard')

    MenuService.register(
        {
            alias: 'performance',
            selectedAliases: [
                'performance',
                'performance-omission-kpi',
                'performance-data-qaqc',
                'performance-kpi-drilling',
                'performance-kpi-goals',
                'performance-data-aggregation',
                'performance-dynamic-dashboards',
                'performance-dynamic-dashboard',
                'performance-dashboard'
            ],
            name: i18n('Performance'),
            component: PerformanceShell,
            order: 1,
            addRoute: true,
            routeUrl: 'performance',
            url: '/#/performance',
            config: {
                showOnMobile: true
            }
        },
        'regular'
    )

    LiveApi.HomePages.register({
        key: 'performance-homepage',
        label: 'Performance',
        existsOnMenu: true,
        url: `/#/performance`
    })
}

require('./24h')
require('./kpiOptions')
require('./widgets')
require('../src/kpiDrillingApps')

KPIPluginConfiguration.setup()
DataPersistenceConfiguration.setup()
addi18n()
